import { CompaniesState, CompaniesTypes } from './types';

const INITIAL_STATE: CompaniesState = {
  companyData: {
    id: '',
    name: '',
    cnpj: '',
    phone: '',
    email: '',
    status: '',
    invoiceDisabled: false,
    Addresses: [],
    Taxes: [],
    createdAt: '',
    updatedAt: '',
    recaptcha: {},
  },
  companyCreated: {
    id: '',
    name: '',
    cnpj: '',
    phone: '',
    email: '',
    status: '',
    invoiceDisabled: false,
    Addresses: [],
    Taxes: [],
    createdAt: '',
    updatedAt: '',
    recaptcha: {},
  },
  companiesList: [],
  companiesListFull: [],
  companyReportList: [],
  paymentMethodList: [],
  paymentMethodData: {
    transportOperatorId: '',
    PaymentBoletoConfig: null,
    PaymentPixConfig: null,
    PaymentEmvConfig: null,
    PaymentCardConfig: null,
    createdAt: '',
    updatedAt: '',
    status: 0,
    id: '',
    type: 'PIX',
    channels: [],
    bank: 'SICREDI',
  },
  boardingHistoryList: [],
  companyBoletoConfigList: [],
  selectedType: [],
  companyAuth: null,
  selectedStatus: '',
  selectedPaymentType: [],
  totalCount: 0,
  error: false,
  loading: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Company
const listCompaniesRequest = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  ...(!action.payload?.isCsvFull && {
    companiesList: INITIAL_STATE.companiesList,
  }),
});

const listCompaniesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  ...(!action.payload?.isCsvFull && {
    companiesList: action.payload.companiesList,
  }),
  ...(action.payload?.isCsvFull && {
    companiesListFull: action.payload.companiesList,
  }),
  totalCount: action.payload.totalCount,
});

const listCompaniesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companiesList: INITIAL_STATE.companiesList,
});

// Company Report
const reportCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyReportList: INITIAL_STATE.companyReportList,
});

const reportCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyReportList: action.payload.companyReportList,
  totalCount: action.payload.totalCount,
});

const reportCompanyFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyReportList: INITIAL_STATE.companyReportList,
});

// List Company
const authCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyAuth: INITIAL_STATE.companyAuth,
});

const authCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyAuth: action.payload.companyAuth,
});

const authCompanyFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyAuth: INITIAL_STATE.companyAuth,
});

// Forgot Password
const forgotPasswordRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const forgotPasswordSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const forgotPasswordFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Filter Company
const filterCompaniesRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companiesList: INITIAL_STATE.companiesList,
});

const filterCompaniesSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companiesList: action.payload.companiesList,
  totalCount: action.payload.totalCount,
});

const filterCompaniesFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companiesList: INITIAL_STATE.companiesList,
});

// Get Company
const getCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyData: INITIAL_STATE.companyData,
});

const getCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyData: action.payload.companyData,
});

const getCompanyFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyData: INITIAL_STATE.companyData,
});

// Create Company
const createCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  companyCreated: INITIAL_STATE.companyCreated,
});

const createCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyCreated: action.payload.companyCreated,
});

const createCompanyFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyCreated: INITIAL_STATE.companyCreated,
});

// Update Company
const updateCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyData: action.payload.companyData,
});

const updateCompanyFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Report Limit
const updateReportLimitRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateReportLimitSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyData: action.payload.companyData,
});

const updateReportLimitFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Company
const deleteCompanyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteCompanySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteCompanyFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// SET SELECTED TYPE
const setSelectedType = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  selectedType: action.payload.selectedType,
});

// SET SELECTED STATUS
const setSelectedStatus = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  selectedStatus: action.payload.selectedStatus,
});

// SET SELECTED PAYMENT TYPE
const setSelectedPaymentType = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  selectedPaymentType: action.payload.selectedPaymentType,
});

// List Payment Method
const listPaymentMethodRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  paymentMethodList: INITIAL_STATE.paymentMethodList,
});

const listPaymentMethodSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  paymentMethodList: action.payload.paymentMethodList,
});

const listPaymentMethodFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  paymentMethodList: INITIAL_STATE.paymentMethodList,
});

// Create Payment Method
const createPaymentMethodRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

const createPaymentMethodSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  paymentMethodData: action.payload.paymentMethodData,
});

const createPaymentMethodFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

// update Payment Method
const updatePaymentMethodRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

const updatePaymentMethodSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  paymentMethodData: action.payload.paymentMethodData,
});

const updatePaymentMethodFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

// List boarding History
const listBoardingHistoryRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  boardingHistoryList: INITIAL_STATE.boardingHistoryList,
});

const listBoardingHistorySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  boardingHistoryList: action.payload.boardingHistoryList,
});

const listBoardingHistoryFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  boardingHistoryList: INITIAL_STATE.boardingHistoryList,
});

// delete Payment Method
const deletePaymentMethodRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

const deletePaymentMethodSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deletePaymentMethodFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  paymentMethodData: INITIAL_STATE.paymentMethodData,
});

// Create Vehicle
const createVehicleRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const createVehicleSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const createVehicleFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Vehicle
const updateVehicleRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateVehicleSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateVehicleFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Vehicle
const deleteVehicleRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteVehicleSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteVehicleFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Company Boleto Config Create Many
const companyBoletoConfigCreateManyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const companyBoletoConfigCreateManySuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const companyBoletoConfigCreateManyFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Company Boleto Config List
const companyBoletoConfigListRequest = (state: any, action: any) => ({
  ...state,
  loading: true,
  error: false,
  companyBoletoConfigList: INITIAL_STATE.companyBoletoConfigList,
});

const companyBoletoConfigListSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  companyBoletoConfigList: action.payload.companyBoletoConfigList,
});

const companyBoletoConfigListFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  companyBoletoConfigList: INITIAL_STATE.companyBoletoConfigList,
});

// Company Boleto Config Update Many
const companyBoletoConfigUpdateManyRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const companyBoletoConfigUpdateManySuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const companyBoletoConfigUpdateManyFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Company Boleto Config Delete
const companyBoletoConfigDeleteRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const companyBoletoConfigDeleteSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const companyBoletoConfigDeleteFaliure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

const reducer = createReducer(INITIAL_STATE, {
  [CompaniesTypes.LIST_COMPANIES_REQUEST]: listCompaniesRequest,
  [CompaniesTypes.LIST_COMPANIES_SUCCESS]: listCompaniesSuccess,
  [CompaniesTypes.LIST_COMPANIES_FAILURE]: listCompaniesFailure,

  [CompaniesTypes.GET_COMPANY_REQUEST]: getCompanyRequest,
  [CompaniesTypes.GET_COMPANY_SUCCESS]: getCompanySuccess,
  [CompaniesTypes.GET_COMPANY_FAILURE]: getCompanyFailure,

  [CompaniesTypes.AUTH_COMPANIES_REQUEST]: authCompanyRequest,
  [CompaniesTypes.AUTH_COMPANIES_SUCCESS]: authCompanySuccess,
  [CompaniesTypes.AUTH_COMPANIES_FAILURE]: authCompanyFaliure,

  [CompaniesTypes.REPORT_COMPANY_REQUEST]: reportCompanyRequest,
  [CompaniesTypes.REPORT_COMPANY_SUCCESS]: reportCompanySuccess,
  [CompaniesTypes.REPORT_COMPANY_FAILURE]: reportCompanyFailure,

  [CompaniesTypes.FORGOT_PASSWORD_REQUEST]: forgotPasswordRequest,
  [CompaniesTypes.FORGOT_PASSWORD_SUCCESS]: forgotPasswordSuccess,
  [CompaniesTypes.FORGOT_PASSWORD_FAILURE]: forgotPasswordFailure,

  [CompaniesTypes.FILTER_COMPANIES_REQUEST]: filterCompaniesRequest,
  [CompaniesTypes.FILTER_COMPANIES_SUCCESS]: filterCompaniesSuccess,
  [CompaniesTypes.FILTER_COMPANIES_FAILURE]: filterCompaniesFailure,

  [CompaniesTypes.CREATE_COMPANY_REQUEST]: createCompanyRequest,
  [CompaniesTypes.CREATE_COMPANY_SUCCESS]: createCompanySuccess,
  [CompaniesTypes.CREATE_COMPANY_FAILURE]: createCompanyFailure,

  [CompaniesTypes.UPDATE_COMPANY_REQUEST]: updateCompanyRequest,
  [CompaniesTypes.UPDATE_COMPANY_SUCCESS]: updateCompanySuccess,
  [CompaniesTypes.UPDATE_COMPANY_FAILURE]: updateCompanyFailure,

  [CompaniesTypes.UPDATE_REPORT_LIMIT_REQUEST]: updateReportLimitRequest,
  [CompaniesTypes.UPDATE_REPORT_LIMIT_SUCCESS]: updateReportLimitSuccess,
  [CompaniesTypes.UPDATE_REPORT_LIMIT_FAILURE]: updateReportLimitFailure,

  [CompaniesTypes.DELETE_COMPANY_REQUEST]: deleteCompanyRequest,
  [CompaniesTypes.DELETE_COMPANY_SUCCESS]: deleteCompanySuccess,
  [CompaniesTypes.DELETE_COMPANY_FAILURE]: deleteCompanyFailure,

  [CompaniesTypes.SET_SELECTED_TYPE]: setSelectedType,
  [CompaniesTypes.SET_SELECTED_STATUS]: setSelectedStatus,
  [CompaniesTypes.SET_SELECTED_PAYMENT_TYPE]: setSelectedPaymentType,

  [CompaniesTypes.LIST_MANAGEMENT_PAYMENT_REQUEST]: listPaymentMethodRequest,
  [CompaniesTypes.LIST_MANAGEMENT_PAYMENT_SUCCESS]: listPaymentMethodSuccess,
  [CompaniesTypes.LIST_MANAGEMENT_PAYMENT_FAILURE]: listPaymentMethodFailure,

  [CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_REQUEST]: createPaymentMethodRequest,
  [CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_SUCCESS]: createPaymentMethodSuccess,
  [CompaniesTypes.CREATE_MANAGEMENT_PAYMENT_FAILURE]: createPaymentMethodFailure,

  [CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_REQUEST]: updatePaymentMethodRequest,
  [CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_SUCCESS]: updatePaymentMethodSuccess,
  [CompaniesTypes.UPDATE_MANAGEMENT_PAYMENT_FAILURE]: updatePaymentMethodFailure,

  [CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_REQUEST]: deletePaymentMethodRequest,
  [CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_SUCCESS]: deletePaymentMethodSuccess,
  [CompaniesTypes.DELETE_MANAGEMENT_PAYMENT_FAILURE]: deletePaymentMethodFailure,

  [CompaniesTypes.LIST_BOARDING_HISTORY_REQUEST]: listBoardingHistoryRequest,
  [CompaniesTypes.LIST_BOARDING_HISTORY_SUCCESS]: listBoardingHistorySuccess,
  [CompaniesTypes.LIST_BOARDING_HISTORY_FAILURE]: listBoardingHistoryFailure,

  [CompaniesTypes.CREATE_VEHICLE_REQUEST]: createVehicleRequest,
  [CompaniesTypes.CREATE_VEHICLE_SUCCESS]: createVehicleSuccess,
  [CompaniesTypes.CREATE_VEHICLE_FAILURE]: createVehicleFailure,

  [CompaniesTypes.UPDATE_VEHICLE_REQUEST]: updateVehicleRequest,
  [CompaniesTypes.UPDATE_VEHICLE_SUCCESS]: updateVehicleSuccess,
  [CompaniesTypes.UPDATE_VEHICLE_FAILURE]: updateVehicleFailure,

  [CompaniesTypes.DELETE_VEHICLE_REQUEST]: deleteVehicleRequest,
  [CompaniesTypes.DELETE_VEHICLE_SUCCESS]: deleteVehicleSuccess,
  [CompaniesTypes.DELETE_VEHICLE_FAILURE]: deleteVehicleFailure,

  [CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_REQUEST]: companyBoletoConfigCreateManyRequest,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_SUCCESS]: companyBoletoConfigCreateManySuccess,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_CREATE_MANY_FAILURE]: companyBoletoConfigCreateManyFaliure,

  [CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_REQUEST]: companyBoletoConfigListRequest,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_SUCCESS]: companyBoletoConfigListSuccess,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_LIST_FAILURE]: companyBoletoConfigListFaliure,

  [CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_REQUEST]: companyBoletoConfigUpdateManyRequest,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_SUCCESS]: companyBoletoConfigUpdateManySuccess,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_UPDATE_MANY_FAILURE]: companyBoletoConfigUpdateManyFaliure,

  [CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_REQUEST]: companyBoletoConfigDeleteRequest,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_SUCCESS]: companyBoletoConfigDeleteSuccess,
  [CompaniesTypes.COMPANY_BOLETO_CONFIG_DELETE_FAILURE]: companyBoletoConfigDeleteFaliure,
});

export default reducer;
